import { createContext } from 'react';

import type { CalendarContextInterface } from '@pages/Calendar/context/CalendarContext.types';

type Nullable<T> = T | null;

export const CalendarContext =
  createContext<Nullable<CalendarContextInterface>>(null);
